<form #loginForm="ngForm" (ngSubmit)="submit()">
  <div class="card ms-lg-3 mt-3 p-5 text-center theme-tile-bg-color">
    <h3>Welcome to {{ environment.domainName }}</h3>
    <h1 class="fw-bold mb-5 theme-text-title-color">Sign In to Participant Account</h1>

    <!-- ACCOUNT NAME -->
    <div class="form-floating mb-2">
      <input class="cwk-form-control form-control" id="account-name" name="account-name" [ngClass]="{'cwk-form-control-required': !credentials.AccountName && (accountName.dirty || accountName.touched)}" [(ngModel)]="credentials.AccountName" placeholder="Account name" type="text" #accountName="ngModel" required>
      <label for="account-name" i18n>Account name</label>
    </div>

    <!-- PASSWORD -->
    <div class="form-floating mb-2 text-start">
      <input class="cwk-form-control form-control" id="password" maxlength="128" name="password" [ngClass]="{'cwk-form-control-required': !credentials.Password && (password.dirty || password.touched)}" [(ngModel)]="credentials.Password" placeholder="Password" type="password" autocomplete="off" #password="ngModel" required/>
      <label for="password" i18n>Password</label>
      <!--small class="ms-3" *ngIf="!credentials.Password && (password.dirty || password.touched)">This field is required</small-->
    </div>

    <!-- ERROR OCCURED -->
    <div class="theme-error-color" *ngIf="status">
      <span class="my-3 text-center" *ngIf="status === 'WAIT'">
        <fa-icon [icon]="faSpinner" animation="spin"></fa-icon>&nbsp;<ng-container i18n>Verifying the credentials</ng-container>
      </span>
      <span class="my-3 text-center" *ngIf="status !== 'WAIT'">{{ status }}</span>
    </div>

    <!-- BUTTONS -->
    <div class="d-grid d-sm-flex gap-3 justify-sm-content-between my-4">
      <button class="btn btn-theme-outline-primary py-3 w-100" (click)="cancel()" type="button">Cancel</button>
      <button class="btn btn-theme-primary py-3 w-100" [disabled]="(!loginForm.form.valid) || (status === 'WAIT')" type="submit">Sign In</button>
    </div>
  </div>
</form>
